var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","px-0":"","pt-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","sm6":"","offset-sm3":"","mt-3":"","mx-auto":""}},[_c('register-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }